import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { palette } from "./palettes";
import { useTheme } from "@/components/theme-provider";

export interface VroomDonutSlice {
  name: string;
  value: number;
  status?: "todo" | "ok" | "rej" | "exp";
}

export function VroomDonut({ data, height = 200 }: { data: VroomDonutSlice[]; height?: number }) {
  const { resolvedTheme } = useTheme();
  const status = palette.status();
  const cat = palette.cat();
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart key={resolvedTheme}>
        <Pie data={data} dataKey="value" innerRadius="60%" outerRadius="90%" stroke="none">
          {data.map((d, i) => (
            <Cell key={d.name} fill={d.status ? status[d.status] : cat[i % cat.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            background: "var(--surface)",
            border: "1px solid var(--line)",
            borderRadius: 5,
            fontSize: 12,
          }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
